import {
    faCalendarDays,
    faThumbsDown,
    faThumbsUp,
    faTruck,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const ThumbsUpIcon = <FontAwesomeIcon icon={faThumbsUp} />;
export const ThumbsDownIcon = <FontAwesomeIcon icon={faThumbsDown} />;
export const TruckIcon = <FontAwesomeIcon icon={faTruck} />;
export const CalendarIcon = <FontAwesomeIcon icon={faCalendarDays} />;
